"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TINKERTOY_METRIC_NAME_ATTRIBUTE = exports.TINKERTOY_METRIC_EVENT_TYPE = void 0;
exports.createNewRelicBrowserTransport = createNewRelicBrowserTransport;
/** Custom NR event type for Tinkertoy performance telemetry (not the built-in BrowserMetric table). */
exports.TINKERTOY_METRIC_EVENT_TYPE = "TinkertoyMetric";
/**
 * Attribute carrying the bounded metric identifier (e.g. tinkertoy.shell_bootstrap).
 * Do not use `name` — on built-in browser tables it is reserved for the page transaction
 * and resolves to values like "Unnamed Transaction".
 */
exports.TINKERTOY_METRIC_NAME_ATTRIBUTE = "metricName";
function isNewRelicBrowserAgent(value) {
    return typeof value === "object" && value !== null;
}
function toNewRelicLogLevel(level) {
    if (level === "fatal") {
        return "error";
    }
    return level;
}
function createNewRelicBrowserTransport() {
    if (typeof window === "undefined") {
        return null;
    }
    const agent = window.newrelic;
    if (!isNewRelicBrowserAgent(agent)) {
        return null;
    }
    return {
        log(level, message, attributes) {
            if (typeof agent.log !== "function") {
                return;
            }
            agent.log(message, {
                level: toNewRelicLogLevel(level),
                customAttributes: attributes,
            });
        },
        noticeError(error, attributes) {
            if (typeof agent.noticeError !== "function") {
                return;
            }
            agent.noticeError(error, attributes);
        },
        recordMetric(name, value, attributes) {
            if (typeof agent.recordCustomEvent !== "function") {
                return;
            }
            agent.recordCustomEvent(exports.TINKERTOY_METRIC_EVENT_TYPE, {
                ...attributes,
                [exports.TINKERTOY_METRIC_NAME_ATTRIBUTE]: name,
                value,
            });
        },
        getCorrelationMetadata() {
            const metadata = {};
            if (typeof agent.interaction === "function") {
                const interaction = agent.interaction();
                if (interaction && typeof interaction === "object") {
                    const traceId = Reflect.get(interaction, "traceId");
                    if (typeof traceId === "string") {
                        metadata.traceId = traceId;
                    }
                }
            }
            return metadata;
        },
    };
}
//# sourceMappingURL=newrelic-browser-transport.js.map